export default __webpack_public_path__ + "static/media/Mexicali-Substation-1-1point-5-768x510.381dd4a4.jpg";